import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { ListPendingInvitationsParams } from 'src/app/core/seller-invitations.service';

@Component({
  selector: 'app-pending-invitations-filter-dialog',
  templateUrl: './pending-invitations-filter-dialog.component.html',
  styleUrls: ['./pending-invitations-filter-dialog.component.scss'],
})
export class PendingInvitationsFilterDialogComponent {
  pending_invitations_filter_form_group: FormGroup = this.form_service.pending_invitations_filter_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<PendingInvitationsFilterDialogComponent>,
    private form_service: FormService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const recipient_email: string | '' = this.pending_invitations_filter_form_group.get(
        this.form_service.recipient_email_label,
      )?.value;
      const company_business_name: string | '' = this.pending_invitations_filter_form_group.get(
        this.form_service.company_business_name_label,
      )?.value;
      const sender_email: string | '' = this.pending_invitations_filter_form_group.get(
        this.form_service.sender_email_label,
      )?.value;
      const company_id: string | '' = this.pending_invitations_filter_form_group.get(
        this.form_service.company_id_label,
      )?.value;

      const params: ListPendingInvitationsParams = {
        recipient_email: recipient_email == '' ? undefined : recipient_email,
        company_business_name: company_business_name == '' ? undefined : company_business_name,
        sender_email: sender_email == '' ? undefined : sender_email,
        company_id: company_id == '' ? undefined : company_id,
      };
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.pending_invitations_filter_form_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.pending_invitations_filter_form_group);
  }
}
